import { Component, OnInit, Input } from '@angular/core';
import * as AOS from 'aos';
import { User } from 'src/app/models/user';
import {
  Post,
  Message,
  Comment,
  Like,
} from 'src/app/core/feed/models/feed-model';
import { Status } from './../../constants';
import { FeedService } from 'src/app/core/feed/services/feed.service';
import { ProfileService } from '../../services/profile.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserfirestoreService } from 'src/app/auth/fire-store/userfirestore.service';

const MAX_LENGTH_DESCRIPTION = 50;
@Component({
  selector: 'makaw-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  @Input() currentStatus: string;
  @Input() currentUser: User;
  @Input() posts: Post[];
  @Input() targetUser: User;
  public status = Status;

  public imageChangedEvent = '';
  public croppedImage = '';
  public pictureURL = '';
  public response: string;
  public editForm: FormGroup;

  constructor(
    private readonly feedService: FeedService,
    private readonly profileService: ProfileService,
    private readonly userService: UserfirestoreService
  ) {}

  public ngOnInit(): void {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
    });

    if (this.currentStatus === Status.Edit) {
      this.editForm = new FormGroup({
        firstName: new FormControl(
          this.targetUser.firstName,
          Validators.required
        ),
        lastName: new FormControl(
          this.targetUser.lastName,
          Validators.required
        ),
        description: new FormControl(
          this.targetUser.description,
          Validators.maxLength(MAX_LENGTH_DESCRIPTION)
        ),
      });
    }
  }

  deletePost(post: Post): void {
    this._deletePost(post);
  }

  updatePhoto(): void {
    this._updatePhoto();
  }

  saveNewData(): void {
    if (this.editForm.valid) {
      const { firstName, lastName, description } = this.editForm.value;
      const newData = {
        firstName,
        lastName,
        description,
      };

      this.userService
        .editUserField(this.targetUser.uid, newData)
        .then(() => (this.response = 'profile.infoUpdated'))
        .catch(() => (this.response = 'profile.failedUpdating'));
    }
  }

  cancelUpdate(): void {
    this.croppedImage = '';
    this.imageChangedEvent = '';
    this.pictureURL = '';
  }

  fileChangeEvent(event: any): void {
    this._fileChangeEvent(event);
  }
  imageCropped(event: ImageCroppedEvent) {
    this._imageCropped(event);
  }

  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  sendComment(message: Message) {
    this._sendComment(message);
  }

  sendLikeEvent(likeInput: any) {
    this._sendLikeEvent(likeInput);
  }

  sendUnlikeEvent(likeInput: any) {
    this._sendUnlikeEvent(likeInput);
  }

  private _deletePost(post: Post) {
    if (this.currentStatus === this.status.Owner) {
      this.feedService.deletePost(post.id);
    }
  }

  // Edit profile methods
  private _updatePhoto() {
    if (this.currentStatus === this.status.Edit)
      this.profileService
        .updatePhoto(this.currentUser.uid)
        .finally(() => this.cancelUpdate());
  }

  private _fileChangeEvent(event: any): void {
    if (this.currentStatus === this.status.Edit) {
      this.imageChangedEvent = event;
      this.profileService.fileChangeEvent(event);
    }
  }
  private _imageCropped(event: ImageCroppedEvent) {
    if (this.currentStatus === this.status.Edit) {
      this.croppedImage = event.base64;
      this.profileService.imageCropped(event);
    }
  }

  // Post methods
  private _sendComment(message: Message) {
    if (
      this.currentStatus === this.status.Friend ||
      this.currentStatus === this.status.Owner
    ) {
      const comment: Comment = {
        content: message.content,
        owner: message.owner,
        author: message.author,
        date: message.date,
      };
      this.feedService.commentPost(message.postId, comment);
    }
  }

  private _sendLikeEvent(likeInput: any) {
    if (
      this.currentStatus === this.status.Friend ||
      this.currentStatus === this.status.Owner
    ) {
      const like: Like = {
        uid: likeInput.uid,
      };
      this.feedService.likePost(likeInput.post, like);
    }
  }

  private _sendUnlikeEvent(likeInput: any) {
    if (
      this.currentStatus === this.status.Friend ||
      this.currentStatus === this.status.Owner
    ) {
      const like: Like = {
        uid: likeInput.uid,
      };
      this.feedService.unlikePost(likeInput.post, like);
    }
  }
}
